import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import AgriminerAppFeatures from "./AgriminerAppFeatures";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import APPBenefit from "../APPBenefits/APPBenefit";

// Main component for AgriMiner App
export default function AgriminerApp() {
  // Overview data sections
  const data1 = [
    "Onboarding Service: Streamlined user onboarding for easy registration.",
    "Doc Verification Service: Ensures document authenticity and compliance.",
  ];

  const data2 = [
    "Site Verification Service: Validates and authenticates locations.",
    "App Demo Service: Provides guidance on app usage, benefits, and schemes.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle={["AgriMiner APP"]}
        DownloadText="Download App"
        dlLink="https://play.google.com/store/apps/details?id=com.gbrapp.agriminer"
        DlBtn="true"
      />

      {/*  Overview  section*/}
      <SolutionEcosystem title="Overview" type="AM" />

      {/* Overview  Features */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Features & Benefits section*/}
      <AgriminerAppFeatures />
      <APPBenefit />
    </>
  );
}

